import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';

import Box from '@mui/material/Box';

import LoginForm from '@ts-core/modules/auth/components/LoginForm';

import { useProfessorAuth } from 'modules/auth/hooks';

const LoginPage = () => {
  const intl = useIntl();

  const { isAuthenticated, signInLoading, onSignIn, signInError } = useProfessorAuth();

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box width={{ xs: '100%', md: 400 }} maxWidth={{ xs: 400, md: undefined }} p={2} my={3} mt={24}>
        <LoginForm
          title={intl.formatMessage({ id: 'loginProfessor.title' })}
          onSubmit={onSignIn}
          error={signInError}
          isSubmitting={signInLoading}
          showResetPassword
          footerText={intl.formatMessage({ id: 'login.areYouStudent' })}
          footerUrl="https://alumno.check.uy"
        />
      </Box>
    </Box>
  );
};

export default LoginPage;
